import type { RouteRecordRaw } from "vue-router"
import administrationRoutes from "@/router/administration"

const settingRoutes: Array<RouteRecordRaw> = [
  {
    path: "/settings",
    name: "settings",
    children: [
      {
        path: "email-settings",
        name: "emailSettings",
        children: [
          {
            path: "integration-email",
            name: "integrationEmail",
            component: () => import("@/views/settings/email-settings/integration-email/IntegrationEmail.vue"),
            meta: {
              pageTitle: "Integration Email Templates",
              breadcrumbs: ["Email Setting", "Integration Email Templates"],
            },
          },
          {
            path: "daily-report",
            name: "dailyReport",
            component: () => import("@/views/settings/email-settings/daily-report/DailyReport.vue"),
            meta: {
              pageTitle: "Daily Report",
              breadcrumbs: ["Email Setting", "Daily Report Settings"],
            },
          },
          {
            path: "email-templates",
            name: "emailTemplates",
            component: () => import("@/views/settings/email-settings/email-templates/EmailTemplates.vue"),
            meta: {
              pageTitle: "Email Templates",
              breadcrumbs: ["Email Setting", "Email Templates"],
            },
          },
          {
            path: "/alert-notification",
            name: "alert",
            component: () => import("@/views/alert/Alert.vue"),
            meta: {
              pageTitle: "System Alert",
              breadcrumbs: ["System Alert"],
            },
          },
          ...administrationRoutes,
          {
            path: "/releases",
            name: "releases",
            component: () => import("@/views/release-note/ReleaseNoteList.vue"),
            meta: {
              pageTitle: "Release Note",
              breadcrumbs: ["Release Note"],
            },
          },
          {
            path: "/glossary",
            name: "glossary",
            component: () => import("@/views/glossary/Glossary.vue"),
            meta: {
              pageTitle: "Glossary",
              breadcrumbs: ["Glossary"],
            },
          },
        ],
      },
    ],
  },
]

export default settingRoutes
